import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';

import {Observable} from 'rxjs';
import {UmpireSurveyAnswer} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class SurveyAnswerService implements CrudService<UmpireSurveyAnswer> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireSurveyAnswer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSurveyAnswer>> {
    return this.http
      .post('/surveys/answers', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireSurveyAnswer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSurveyAnswer>> {
    return this.http
      .patch(`/surveys/answers/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
